/* upk-rails.js, shared engine for PDP rails:
   [data-upk-rail="ctl"]    Complete the Look, four look cards (this product
                            + 3 complementary pieces, different mix per card).
   [data-upk-rail="mix"]    You May Also Like, single-product cards drawn
                            from EVERY complementary category, rendered as a
                            slider/carousel on every device (desktop gets
                            click arrows too, wired in wireArrows()).
   [data-upk-rail="recent"] Recently Viewed, localStorage history rail.
   Both "mix" and "recent" render as full collection-grid-style .pc cards
   (see pcCard() below). 21 Oct (Zainab): the card is the same as
   snippets/card-product.liquid now: the product's own Judge.me rating as a chip on the photo, category and swatches,
   the name, and the price with a square + button (data-pc-atc, so one-option pieces go straight to the bag and pieces
   that need a choice open the shared Quick View, via the SAME global listener the collection grid uses).
   Band+charm builder products (e.g. the DIY Charm/Shimmer Band items) have
   NO purchasable Shopify variants of their own, their real Shopify price
   is ₹0, the actual price only exists via a starting_price metafield that
   this lightweight /products/{handle}.js endpoint doesn't expose. For
   these, pcCard() uses the price/compare/needsOptions ALREADY correctly
   computed by Liquid (custom.starting_price override) when the product was
   first recorded on its own PDP, rather than trusting the live ₹0 figure
   or giving up and falling back to a lesser card.
   STYLE MATCHING: the engine detects the viewed product's design motif
   (evil eye, pearl, zircon/diamond, butterfly, heart, floral, celestial,
   kundan, snake, infinity…) and prioritises pieces in the SAME style across
   every category, an Evil Eye bangle recommends Evil Eye earrings, rings,
   necklaces… before generic tone matches.
   WEEKLY ROTATION: ctl + mix picks are offset by hash(product handle + week),
   so every product shows its own selection and it rotates weekly; session
   cache keys carry the week so stale picks expire automatically.
   925/sterling wall and men's wall (men's pieces never mix into women's
   recommendations, and vice versa, matches bare "Men" as well as "Men's"/
   "Mens"/"Gents") apply to every rail. */
(function () {
  'use strict';
  if (window.__upkRails) return; window.__upkRails = 1;

  var CATS = [
    ['earrings', /\b(earrings?|studs?|hoops?|jhumk\w*|ear\s?cuffs?)\b/, 'Earrings'],
    ['necklace', /\b(necklaces?|pendants?|chains?|chokers?|mangalsutras?|lariats?)\b/, 'Necklace'],
    ['anklet', /\b(anklets?|payal)\b/, 'Anklet'],
    ['bracelet', /\b(bracelets?)\b/, 'Bracelet'],
    ['bangle', /\b(bangles?|kadas?)\b/, 'Bangles'],
    ['ring', /\b(rings?)\b/, 'Ring']
  ];
  var COMP = {
    bangle: ['earrings', 'ring', 'necklace', 'bracelet'],
    bracelet: ['earrings', 'ring', 'necklace', 'bangle'],
    earrings: ['necklace', 'ring', 'bangle', 'bracelet'],
    necklace: ['earrings', 'ring', 'bangle', 'bracelet'],
    ring: ['earrings', 'necklace', 'bangle', 'bracelet'],
    anklet: ['earrings', 'ring', 'necklace', 'bracelet']
  };
  var MIX_ORDER = ['earrings', 'necklace', 'ring', 'bracelet', 'bangle', 'anklet'];
  var LABEL = { earrings: 'Earrings', necklace: 'Necklace', bangle: 'Bangle', bracelet: 'Bracelet', ring: 'Ring', anklet: 'Anklet' };
  var SILVER = /\b925\b|sterling/i;
  var MENS = /\bmen'?s\b|\bmens\b|\bmen\b|\bgents?\b|\bboy'?s\b|\bfor him\b|\bhim\b|\bmale\b/i;
  var EXCLUDE = /stack|combo|set of|gift box|pouch|builder|alphabet|initials?\b|\bletters?\b|\bcustom\b|personali[sz]ed|gift card|gift note/i;
  var MIN_PRICE = 50000;

  var STYLES = [
    ['evil eye', /evil\s*eye|nazar/i],
    ['butterfly', /butterfl/i],
    ['snake', /\bsnakes?\b|serpent/i],
    ['infinity', /infinit/i],
    ['pearl', /pearls?|\bmoti\b/i],
    ['kundan', /kundan|polki|meena/i],
    ['heart', /\bhearts?\b|\blove\b/i],
    ['flower', /flowers?|floral|\blotus\b|\bdaisy\b|\btulip\b|\brose\b/i],
    ['star', /\bstars?\b|\bmoons?\b|celestial|constellation|galaxy/i],
    ['leaf', /\bleaf\b|\bleaves\b/i],
    ['diamond', /diamonds?|solitaire|zircon|\bcz\b|american diamond/i]
  ];

  var WEEK = (function () { var d = new Date(); var j = new Date(d.getFullYear(), 0, 1); return d.getFullYear() + 'w' + Math.floor(((d - j) / 864e5 + j.getDay()) / 7); })();
  function hash(s) { var h = 0; for (var i = 0; i < s.length; i++) { h = (h * 31 + s.charCodeAt(i)) | 0; } return Math.abs(h); }

  function catOf(t) { t = (t || '').toLowerCase(); for (var i = 0; i < CATS.length; i++) { if (CATS[i][1].test(t)) return CATS[i][0]; } return null; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function short(t) { return String(t).split('|')[0].trim(); }
  function rotate(arr, n) { if (!arr.length) return arr; n = n % arr.length; return arr.slice(n).concat(arr.slice(0, n)); }
  var fmt = (function () {
    var mf = window.__upkMFmt || '\u20B9{{amount}}';
    return function (paise) {
      var s = (Math.round(paise) / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      return mf.replace(/\{\{\s*amount[^}]*\}\}/, s).replace(/<[^>]+>/g, '');
    };
  })();
  function jget(u) { return fetch(u).then(function (r) { if (!r.ok) throw new Error(u); return r.json(); }); }

  function cartAdd(items, btn, doneTxt) {
    if (btn.disabled) return;
    btn.disabled = true; var t = btn.textContent; btn.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.status) { btn.textContent = 'N/A'; setTimeout(function () { btn.disabled = false; btn.textContent = t; }, 1500); return; }
      var dr = document.querySelector('cart-drawer');
      if (dr && d && d.sections && typeof dr.renderContents === 'function') dr.renderContents(d);
      btn.classList.add('is-done'); btn.textContent = doneTxt || '\u2713 Added';
      setTimeout(function () { btn.classList.remove('is-done'); btn.disabled = false; btn.textContent = t; }, 1900);
    }).catch(function () { btn.disabled = false; btn.textContent = t; });
  }

  function suggest(base, q) {
    var u = base + '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide';
    return jget(u).then(function (d) {
      var l = (d.resources && d.resources.results && d.resources.results.products) || [];
      return l.map(function (p) { return { handle: p.handle, title: p.title || '' }; });
    }).catch(function () { return []; });
  }
  function pjs(base, h) {
    return jget(base + '/products/' + h + '.js').then(function (p) {
      var v = null, i;
      for (i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
      v = v || p.variants[0];
      return {
        handle: p.handle, title: p.title,
        image: (p.images && p.images[0]) || p.featured_image || null,
        variantId: v ? v.id : null, price: v ? v.price : p.price,
        compare: (v && v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : null,
        available: p.available, url: base + '/products/' + p.handle,
        needsOptions: p.variants.length > 1
      };
    });
  }
  /* Full product.js payload (used only for the rich pcCard() rendering,
     which needs tags/options/variant-images the lightweight pjs()
     summary above doesn't carry). */
  function pfull(base, h) {
    return jget(base + '/products/' + h + '.js');
  }

  function poolFor(base, P, cat, wallOk, toneQ, seed, styleQ, styleRe) {
    var queries = [];
    if (styleQ) queries.push(suggest(base, styleQ + ' ' + cat));
    queries.push(suggest(base, toneQ + ' ' + cat));
    queries.push(suggest(base, cat));
    return Promise.all(queries).then(function (r) {
      var seen = {}; seen[P.handle] = 1;
      var styleHits = [], rest = [];
      [].concat.apply([], r).forEach(function (c) {
        if (seen[c.handle]) return;
        if (catOf(c.title) !== cat) return;
        if (!wallOk(c.title)) return;
        seen[c.handle] = 1;
        if (styleRe && styleRe.test(c.title)) styleHits.push(c); else rest.push(c);
      });
      var cand = rotate(styleHits, seed).concat(rotate(rest, seed));
      return Promise.all(cand.slice(0, 5).map(function (c) { return pjs(base, c.handle).catch(function () { return null; }); }));
    }).then(function (all) {
      return all.filter(function (p) { return p && p.available && p.variantId && p.price >= MIN_PRICE && wallOk(p.title); }).slice(0, 3);
    });
  }

  function railEnv(cfg) {
    var P = cfg.product;
    var base = (cfg.root || '/').replace(/\/$/, '');
    var tags = (P.tags || []).join(' ');
    var blob = P.title + ' ' + (P.type || '') + ' ' + tags;
    var curSilver = SILVER.test(blob), curMens = MENS.test(blob);
    var styleBlob = blob.replace(/rose\s*gold/ig, '');
    var styleQ = null, styleRe = null;
    for (var i = 0; i < STYLES.length; i++) {
      if (STYLES[i][1].test(styleBlob)) { styleQ = STYLES[i][0]; styleRe = STYLES[i][1]; break; }
    }
    return {
      P: P, base: base,
      seed: hash(P.handle + ':' + WEEK),
      myCat: catOf(blob),
      styleQ: styleQ, styleRe: styleRe,
      toneQ: /rose\s?gold/i.test(P.title) ? 'rose gold' : (curSilver ? '925 silver' : 'golden'),
      tone: /rose\s?gold/i.test(P.title) ? 'rose' : (curSilver ? 'silver' : 'gold'),
      wallOk: function (t) {
        if (curSilver !== SILVER.test(t)) return false;
        if (curMens !== MENS.test(t)) return false;
        return !EXCLUDE.test(t);
      }
    };
  }

  /* ================= Complete the Look (look cards) ================= */
  function initCTL(el, cfg) {
    var env = railEnv(cfg), P = env.P, base = env.base, seed = env.seed;
    var track = el.querySelector('[data-rail-track]');
    var myCat = env.myCat || 'bangle';
    var myLabel = (LABEL[myCat] || 'piece').toLowerCase();
    var comps = COMP[myCat] || COMP.bangle;
    var toneWord = env.tone === 'rose' ? 'Rosegold' : (env.tone === 'silver' ? 'Silver' : 'Golden');
    var key = 'upkCtl4:' + P.handle + ':' + WEEK;
    var styleWord = env.styleQ ? env.styleQ.replace(/\b\w/g, function (m) { return m.toUpperCase(); }) : null;
    var LOOK_META = [
      { name: (styleWord ? styleWord + ' Signature Stack' : toneWord + ' Signature Stack'), badge: 'Best Match' },
      { name: 'The Office Edit', badge: 'Office Wear' },
      { name: 'Party Statement Stack', badge: 'Party Wear' },
      { name: 'Everyday Easy Stack', badge: 'Daily Wear' }
    ];
    var LOOK_CATS = [[0, 1, 2], [0, 2, 3], [1, 2, 3], [0, 1, 3]];

    var LOOKS = [];

    function lookCard(look) {
      var t = P.price, m = P.compare || P.price;
      look.pieces.forEach(function (c) { t += c.price; m += (c.compare || c.price); });
      var pct = m > t ? Math.round((m - t) * 100 / m) : 0;
      var media = '<img class="is-main" src="' + esc(P.image || '') + '" alt="' + esc(short(P.title)) + '" loading="lazy">';
      look.pieces.forEach(function (c) {
        media += '<img src="' + esc(c.image || '') + '" alt="' + esc(short(c.title)) + '" title="' + esc(short(c.title)) + '" loading="lazy">';
      });
      var rows = '<div class="upk-look-row"><span>' + esc(short(P.title)) + '</span><b>' + fmt(P.price) + '</b></div>';
      look.pieces.forEach(function (c) {
        rows += '<div class="upk-look-row"><span>' + esc(short(c.title)) + '</span><b>' + fmt(c.price) + '</b></div>';
      });
      var el2 = document.createElement('div');
      el2.className = 'upk-look-card';
      el2.innerHTML =
        '<div class="upk-look-media"><span class="upk-look-badge">' + esc(look.badge) + '</span>' + media + '</div>' +
        '<h4 class="upk-look-name">' + esc(look.name) + '</h4>' +
        '<p class="upk-look-pieces">' + (look.pieces.length + 1) + ' pieces \u00b7 incl. this ' + esc(myLabel) + '</p>' +
        '<div class="upk-look-list">' + rows + '</div>' +
        '<div class="upk-look-price"><b>' + fmt(t) + '</b>' + (m > t ? '<s>' + fmt(m) + '</s><span class="upk-rail-chip">SAVE ' + pct + '%</span>' : '') + '</div>' +
        '<button type="button" class="upk-rail-add" data-look-add="' + LOOKS.length + '">Add Stack to Bag</button>';
      return el2;
    }

    function render(looks) {
      track.innerHTML = '';
      LOOKS.length = 0;
      if (!looks || !looks.length) { el.hidden = true; return; }
      looks.forEach(function (l) { track.appendChild(lookCard(l)); LOOKS.push(l); });
      el.hidden = false;
    }

    track.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-look-add]'); if (!btn) return;
      var look = LOOKS[+btn.getAttribute('data-look-add')]; if (!look) return;
      var bid = 'look-' + P.id + '-' + Date.now();
      var items = [{ id: P.variantId, quantity: 1 }].concat(look.pieces.map(function (c) { return { id: c.variantId, quantity: 1 }; }));
      items = items.map(function (it) { it.properties = { 'Bundle': look.name, '_upk_bundle_id': bid, '_upk_bundle_name': look.name }; return it; });
      cartAdd(items, btn, 'Added \u2713');
    });

    var cached = null; try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    if (cached) { render(cached); return; }

    el.hidden = false;
    for (var i = 0; i < 4; i++) { var s = document.createElement('div'); s.className = 'upk-rail-skel'; track.appendChild(s); }

    Promise.all(comps.map(function (cat, ci) {
      return poolFor(base, P, cat, env.wallOk, env.toneQ, seed + ci, env.styleQ, env.styleRe);
    })).then(function (pools) {
      function pick(ci, offset, usedH) {
        var pool = pools[ci];
        if (!pool || !pool.length) return null;
        for (var k = 0; k < pool.length; k++) {
          var p = pool[(offset + k) % pool.length];
          if (!usedH[p.handle]) { usedH[p.handle] = 1; return p; }
        }
        return null;
      }
      var looks = [];
      for (var li = 0; li < 4; li++) {
        var usedH = {};
        var pieces = [];
        LOOK_CATS[li].forEach(function (ci) {
          var p = pick(ci, li + seed, usedH);
          if (p) pieces.push(p);
        });
        if (pieces.length >= 2) {
          looks.push({ name: LOOK_META[li].name, badge: LOOK_META[li].badge, pieces: pieces });
        }
      }
      try {
        sessionStorage.setItem(key, JSON.stringify(looks.map(function (l) {
          return { name: l.name, badge: l.badge, pieces: l.pieces.map(function (c) { return { handle: c.handle, title: c.title, image: c.image, variantId: c.variantId, price: c.price, compare: c.compare }; }) };
        })));
      } catch (e) {}
      render(looks);
    }).catch(function () { render(null); });
  }

  /* ================= Collection-grid-style card (You May Also Like + Recently Viewed) =================
     Builds the SAME markup/classes as snippets/card-product.liquid's .pc card, from
     a full /products/{handle}.js payload (p), with the ORIGINAL lightweight pick
     object (pick: {price, compare, needsOptions, variantId, image, url, cat, ...})
     as a fallback source for anything the live payload can't provide (band+charm
     builder products with no real Shopify variants, see file header). Reuses
     the site's existing GLOBAL delegated listeners instead of attaching its own:
       - data-pc-atc / data-pc-sw / data-pc-wish click handling -> upk-quickview.js
       - data-pc-wish-id heart persistence               -> upk-wishlist.js
     One honest gap: the ribbon badges are driven by COLLECTION membership on the server, which this lightweight product
     endpoint doesn't expose, so no badge is shown here rather than guessing one.
     Never throws, every field access below is guarded. */
  function imgW(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function swatchHex(v) {
    /* P1: one finish-to-colour map (snippets/upk-swatch-map.liquid), printed once as window.UPK_SWATCHES by layout/theme.liquid. */
    return (window.upkSwatch && window.upkSwatch(v)) || 'var(--upk-line)';
  }
  /* P4.5 (decision 132): never an invented rating. 21 Oct: as on card-product.liquid, the chip on the photo shows only
     the product's own Judge.me rating and count (recorded with the pick on its own product page); no chip otherwise. */
  /* P13e-delta.5 (D12, decision 132 restored): a pick with no reviews of its own shows the store-wide Judge.me average with the
     label "store rating" when layout/theme.liquid prints window.UPK_STORE_RATING (the theme setting is on); no chip otherwise. */
  function chipHtml(pick) {
    pick = pick || {};
    var rv = Number(pick.rating) || 0, rc = Number(pick.count) || 0, store = false;
    if (!(rv > 0 && rc > 0)) { var st = window.UPK_STORE_RATING || {}; rv = Number(st.rating) || 0; rc = Number(st.count) || 0; store = true; }
    if (!(rv > 0 && rc > 0)) return '';
    return '<span class="pc-chip' + (store ? ' pc-chip--store' : '') + '" aria-label="' + (store ? 'Store rating ' : 'Rated ') + rv.toFixed(1) + ' out of 5 from ' + rc + ' reviews">' + rv.toFixed(1) + ' <i aria-hidden="true">&#9733;</i> | ' + rc + (store ? ' <em class="pc-chip__lbl">store rating</em>' : '') + '</span>';
  }
  function pcCard(p, pick) {
    if (!p) return null;
    pick = pick || {};

    var variants = Array.isArray(p.variants) ? p.variants : [];
    var v = null;
    for (var i = 0; i < variants.length; i++) { if (variants[i] && variants[i].available) { v = variants[i]; break; } }
    v = v || variants[0] || null;

    /* Band+charm builder products (no usable variant, or the live variant price is ₹0): use the price/compare Liquid
       computed when the product was first viewed on its own PDP, and always treat them as needing a choice. */
    var isBuilder = !v || !v.price;
    var price = isBuilder ? (pick.price != null ? pick.price : (v ? v.price : p.price)) : v.price;
    var compareRaw = isBuilder ? pick.compare : (v && v.compare_at_price > v.price ? v.compare_at_price : null);
    var onSale = compareRaw && compareRaw > price;
    var needsOptions = isBuilder ? true : variants.length > 1;
    var vid = isBuilder ? (pick.variantId || (v ? v.id : '')) : v.id;
    var available = (p.available != null ? p.available : pick.available);
    if (available == null) available = true;

    var img1 = (p.images && p.images[0]) || (p.featured_image || '') || pick.image || '';
    var img2 = (p.images && p.images[1]) || '';

    var colorIdx = -1;
    (Array.isArray(p.options) ? p.options : []).forEach(function (opt, idx) {
      var n = ((opt && opt.name) || '').toLowerCase();
      if (colorIdx === -1 && (n === 'color' || n === 'colour')) colorIdx = idx;
    });
    var swHtml = '';
    if (colorIdx > -1) {
      var bycol = {}, order = [];
      variants.forEach(function (variant) {
        if (!variant) return;
        var val = variant.options && variant.options[colorIdx];
        if (!val) return;
        if (!bycol[val]) { bycol[val] = { vid: variant.id, img: "" }; order.push(val); }
        if (!bycol[val].img && variant.featured_image) { bycol[val].img = imgW(variant.featured_image.src, 533); bycol[val].vid = variant.id; }
      });
      order.slice(0, 4).forEach(function (val) {
        var sw = bycol[val];
        swHtml += "<i style=\"background:" + swatchHex(val) + "\" title=\"" + esc(val) + "\" data-pc-sw" + (sw.img ? " data-pc-sw-img=\"" + esc(sw.img) + "\"" : "") + (sw.vid ? " data-pc-sw-vid=\"" + sw.vid + "\"" : "") + "></i>";
      });
    }

    var title = p.title || pick.title || '';
    var url = p.url || pick.url || '#';
    var type = p.type || pick.cat || 'Jewellery';

    var wrap = document.createElement('div');
    wrap.className = 'upk-rail-card pc-card-wrapper';
    wrap.setAttribute('data-pc-url', url);
    wrap.setAttribute('data-pc-options', needsOptions ? 'true' : 'false');
    wrap.setAttribute('data-pc-available', available ? 'true' : 'false');
    wrap.setAttribute('data-pc-vid', vid || '');
    wrap.innerHTML =
      '<div class="pc">' +
        '<div class="pc-img">' +
          '<button type="button" class="pc-wish" aria-label="Add ' + esc(short(title)) + ' to wishlist" aria-pressed="false" data-pc-wish data-pc-wish-id="' + (p.id || '') + '">&#9825;</button>' +
          (img1 ? '<img class="pc-i1" src="' + esc(imgW(img1, 533)) + '" alt="' + esc(short(title)) + '" loading="lazy">' : '') +
          (img2 ? '<img class="pc-i2" src="' + esc(imgW(img2, 533)) + '" alt="" loading="lazy">' : '') +
          chipHtml(pick) +
        '</div>' +
        '<div class="pc-body">' +
          '<div class="pc-cat-row">' +
            '<span class="pc-cat">' + esc(type) + '</span>' +
            (swHtml ? '<span class="sw">' + swHtml + '</span>' : '') +
          '</div>' +
          '<h3 class="pc-name"><a href="' + esc(url) + '">' + esc(short(title)) + '</a></h3>' +
          '<div class="pc-row">' +
            '<span class="pc-price">' + (isBuilder && price > 0 ? 'From&#160;' : '') + fmt(price) + (onSale ? '<s>' + fmt(compareRaw) + '</s>' : '') + '</span>' +
            '<button type="button" class="pc-plus" data-pc-atc aria-label="' + (needsOptions ? 'Choose options for ' : 'Add ') + esc(short(title)) + (needsOptions ? '' : ' to cart') + '">+</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    return wrap;
  }

  /* Ultimate fallback, only reached if the /products/{handle}.js fetch itself fails outright (network error, 404). */
  function pcCardFromPickOnly(pick) {
    var stub = {
      id: null, title: pick.title, url: pick.url, type: pick.cat,
      images: pick.image ? [pick.image] : [], variants: [], available: pick.available !== false
    };
    return pcCard(stub, pick);
  }

  function buildRichOrFallback(base, pick) {
    return pfull(base, pick.handle).catch(function () { return null; }).then(function (full) {
      var el = null;
      try { el = pcCard(full, pick); } catch (e) { el = null; }
      return el || pcCardFromPickOnly(pick);
    });
  }

  function wireArrows(el) {
    var wrap = el.querySelector('.upk-rail-track-wrap');
    var track = el.querySelector('[data-rail-track]');
    if (!wrap || !track) return null;
    var prev = wrap.querySelector('[data-rail-prev]');
    var next = wrap.querySelector('[data-rail-next]');
    if (!prev || !next) return null;
    function stepPx() {
      var card = track.querySelector('.upk-rail-card');
      return card ? Math.round(card.getBoundingClientRect().width) + 14 : Math.round(track.clientWidth * 0.8);
    }
    function update() {
      var scrollable = track.scrollWidth > track.clientWidth + 4;
      prev.hidden = !scrollable; next.hidden = !scrollable;
      if (!scrollable) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    if (!prev.dataset.wired) {
      prev.dataset.wired = '1'; next.dataset.wired = '1';
      prev.addEventListener('click', function () { track.scrollBy({ left: -stepPx(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: stepPx(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update);
      window.addEventListener('resize', update);
    }
    return update;
  }

  function initMix(el, cfg) {
    var env = railEnv(cfg), P = env.P, base = env.base, seed = env.seed;
    var track = el.querySelector('[data-rail-track]');
    var max = cfg.max || 8;
    var order = MIX_ORDER.filter(function (c) { return c !== env.myCat; });
    order = rotate(order, seed);
    var key = 'upkMix2:' + P.handle + ':' + max + ':' + WEEK;
    var updateArrows = wireArrows(el);

    function render(items) {
      if (!items || items.length < 3) { el.hidden = true; return; }
      track.innerHTML = '';
      el.hidden = false;
      var skels = items.map(function () { var sk = document.createElement('div'); sk.className = 'upk-rail-skel'; track.appendChild(sk); return sk; });
      Promise.all(items.map(function (p) { return buildRichOrFallback(base, p); }))
        .then(function (cards) {
          skels.forEach(function (sk) { if (sk.parentNode) sk.parentNode.removeChild(sk); });
          cards.forEach(function (c) { if (c) track.appendChild(c); });
          if (updateArrows) setTimeout(updateArrows, 60);
        });
    }

    var cached = null; try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    if (cached) { render(cached); return; }

    el.hidden = false;
    for (var i = 0; i < 4; i++) { var s = document.createElement('div'); s.className = 'upk-rail-skel'; track.appendChild(s); }

    Promise.all(order.map(function (cat, ci) {
      return poolFor(base, P, cat, env.wallOk, env.toneQ, seed + ci, env.styleQ, env.styleRe);
    })).then(function (pools) {
      var picks = [], seen = {};
      for (var round = 0; round < 3 && picks.length < max; round++) {
        for (var i = 0; i < pools.length && picks.length < max; i++) {
          var p = pools[i][round];
          if (p && !seen[p.handle]) {
            seen[p.handle] = 1;
            p.cat = LABEL[order[i]] || 'Jewellery';
            picks.push(p);
          }
        }
      }
      try { sessionStorage.setItem(key, JSON.stringify(picks)); } catch (e) {}
      render(picks);
    }).catch(function () { render(null); });
  }

  /* ================= Recently Viewed ================= */
  var LS_KEY = 'upkRecent';
  function recordRecent(P, base) {
    try {
      var arr = JSON.parse(localStorage.getItem(LS_KEY) || '[]');
      arr = arr.filter(function (x) { return x && x.handle !== P.handle; });
      var cat = catOf(P.title + ' ' + (P.type || ''));
      arr.unshift({
        handle: P.handle, title: P.title, image: P.image,
        price: P.price, compare: P.compare, variantId: P.variantId,
        url: P.url || (base + '/products/' + P.handle),
        needsOptions: !!P.needsOptions,
        rating: Number(P.rating) || 0, count: Number(P.count) || 0,
        cat: (cat ? LABEL[cat] : (P.type || 'Jewellery'))
      });
      localStorage.setItem(LS_KEY, JSON.stringify(arr.slice(0, 12)));
    } catch (e) {}
  }
  function initRecent(el, cfg) {
    var P = cfg.product, base = (cfg.root || '/').replace(/\/$/, '');
    var track = el.querySelector('[data-rail-track]');
    var items = [];
    try { items = JSON.parse(localStorage.getItem(LS_KEY) || '[]'); } catch (e) {}
    items = items.filter(function (x) { return x && x.handle && x.handle !== P.handle; }).slice(0, cfg.max || 4);

    if (items.length) {
      el.hidden = false;
      track.innerHTML = '';
      var skels = items.map(function () { var s = document.createElement('div'); s.className = 'upk-rail-skel'; track.appendChild(s); return s; });
      Promise.all(items.map(function (p) { return buildRichOrFallback(base, p); }))
        .then(function (cards) {
          skels.forEach(function (s) { if (s.parentNode) s.parentNode.removeChild(s); });
          cards.forEach(function (c) { if (c) track.appendChild(c); });
          el.hidden = false;
        });
    } else {
      el.hidden = true;
    }
    recordRecent(P, base);
  }

  /* P12.3e (Cowork review 19 Oct, item 1): the rails start on the first interaction (pointer, touch, key or wheel) or
     6 s after the load event, whichever comes first; the rails sit far below the fold. */
  var railQueue = [], railGo = false;
  function startRails() { if (railGo) return; railGo = true; railQueue.splice(0).forEach(function (f) { try { f(); } catch (e) {} }); }
  ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (ev) { window.addEventListener(ev, startRails, { once: true, passive: true, capture: true }); });
  if (document.readyState === 'complete') setTimeout(startRails, 6000); else window.addEventListener('load', function () { setTimeout(startRails, 6000); });
  function boot() {
    document.querySelectorAll('[data-upk-rail]').forEach(function (el) {
      if (el.dataset.railInit) return;
      var cs = el.querySelector('script[data-rail-config]');
      if (!cs) return;
      var cfg; try { cfg = JSON.parse(cs.textContent); } catch (e) { return; }
      if (!cfg || !cfg.product) return;
      el.dataset.railInit = '1';
      var run = function () {
        if (el.dataset.upkRail === 'ctl') initCTL(el, cfg);
        else if (el.dataset.upkRail === 'mix') initMix(el, cfg);
        else if (el.dataset.upkRail === 'recent') initRecent(el, cfg);
      };
      if (railGo) run(); else railQueue.push(run);
    });
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
